class Config {
    static data() {
        return {
            vuetable: {
                pagination: {
                    per_page: 12
                }
            },
            moment: {
                format: {
                    date: 'DD/MM/YYYY',
                    timestamp: 'YYYY-MM-DD HH:mm:ss',
                    received: 'YYYY-MM-DD HH:mm:ss'
                },
            }
        };
    }

    get(configString) {
        let result = Config.data();
        let configParts = configString.split('.')
        for (let index in configParts) {
            result = result[configParts[index]];
        }

        return result;
    }
}

export default Config;